import "./info.scss";

export const Info = ({ data }) => (
  <div className="widget-info">
    <div className="widget-info__title">{data.title}</div>
    <div className="widget-info__text">{data.text}</div>
  </div>
);
